import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AutoCompleteCompleteEvent, AutoCompleteModule, AutoCompleteSelectEvent } from 'primeng/autocomplete';
import { MedicalService } from '../../../../services/medical.service';
import { FormsModule } from '@angular/forms';
import { DatePipe, NgIf, SlicePipe } from '@angular/common';
import { CardModule } from 'primeng/card';
import { ButtonModule } from 'primeng/button';
import { plainToInstance } from 'class-transformer';
import { Procedure } from '../../../../models/procedure';

@Component({
  selector: 'app-procedure-selector',
  standalone: true,
  imports: [AutoCompleteModule, FormsModule, DatePipe, CardModule, ButtonModule, SlicePipe, NgIf],
  templateUrl: './procedure-selector.component.html',
  styleUrl: './procedure-selector.component.scss'
})
export class ProcedureSelectorComponent 
{
  @Input() procedure? : Procedure;
  @Output() procedureChange : EventEmitter<Procedure> = new EventEmitter<Procedure>();
  @Output() procedureSelected = new EventEmitter<Procedure>();

  constructor(private _medicalService:MedicalService)
  {

  }

  procedureSuggestions: Procedure[] = [];

  procedureSearch(event:AutoCompleteCompleteEvent )
  {
    //Update the suggestions to our query results
    this._medicalService.searchProcedures(event.query)
    .then
    (
      procedures => 
        {
          this.procedureSuggestions = procedures;
        }
    )
  }

  selectProcedure(event: AutoCompleteSelectEvent)
  {
    var procedure = plainToInstance(Procedure, this.procedure);
    this.procedureSelected.emit(procedure);
    this.procedureChange.emit(procedure);
  }

  resetSelection()
  {
    this.procedure = undefined;
  }

}
